import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hpsfir-card couponcode" }

import {
  HpsfirProTable,
  HpsfirProTableColumn,
  HpsfirProTableData,
  HpsfirProTableFilter,
  HpsfirProTableGetDataFunction,
  useBaseAsync,
} from 'hpsfir-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<HpsfirProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof HpsfirProTable>>();
const couponPackageOptions = ref<{ label: string; value: number }[]>([]);

const addInitValue = {
  limit: 0,
};

const conditionsInitValue = {};

// 获取优惠券套餐选项
const getCouponPackageOptions = useBaseAsync(async() => {
  try {
    const res = await useApi().couponpackageApi.listCouponPackagecouponpackage({
      conditions: {},
    });

    couponPackageOptions.value = (res.data.data || []).map((item: any) => ({
      label: `${item.name} (${item.price}元)`,
      value: item.id,
    }));
  } catch (error) {
    console.error('获取优惠券套餐列表失败:', error);
    ElMessage.error('获取优惠券套餐列表失败');
  }
});

// 创建列定义
const createColumns = () => [
  {
    name: 'couponPackageId',
    label: '优惠券套餐',
    type: 'select',
    isCondition: true,
    rule: [{ required: true, message: '请选择优惠券套餐' }],
    width: 200,
    options: couponPackageOptions.value,
  },
  {
    name: 'code',
    label: '兑换码',
    type: 'string',
    isCondition: true,
    rule: [{ required: true, message: '请输入兑换码' }],
    width: 150,
  },
  {
    name: 'lmt',
    label: '单用户限量',
    type: 'number',
    rule: [{ required: true, message: '请输入单用户限量' }],
    width: 140,
  },
  {
    name: 'expireAt',
    label: '有效期',
    type: 'datepick',
    pickType: 'datetime',
    rule: [{ required: true, message: '请选择有效期' }],
    width: 160,
  },

  /* {
    name: 'createTime',
    label: '创建时间',
    type: 'string',
    hideEdit: true,
    hideCreate: true,
    width: 160,
  }, */
] as HpsfirProTableColumn[];

// 初始化
const init = useBaseAsync(async() => {
  await getCouponPackageOptions();
  columns.value = createColumns();
});

const operates: any[] = [];

const loading = ref(false);

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().couponcodeApi.pageCouponCodecouponcode({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }

        conditions[key] = val;

        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data?.map((item: any) => {
        // 为显示添加套餐名称
        const packageOption = couponPackageOptions.value.find((opt) => opt.value === item.couponPackageId);
        return {
          ...item,
          couponPackageName: packageOption?.label || `套餐ID: ${item.couponPackageId}`,
        };
      }) || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您确定要删除兑换码"${row.code || '未命名'}"吗？此操作不可恢复，请谨慎操作。`;

const addFun = useBaseAsync(async(data: any) => {
  await useApi().couponcodeApi.addCouponCodecouponcode({
    couponCodeAdminVo: {
      ...data,
    },
  });
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  await useApi().couponcodeApi.updateCouponCodecouponcode({
    couponCodeAdminVo: {
      ...data,
    },
  });
  ElMessage.success('修改成功');
});

const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().couponcodeApi.delCouponCodecouponcode(data.id);
  ElMessage.success('删除成功');
});

Promise.all([init()]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(HpsfirProTable), {
      ref_key: "tableRef",
      ref: tableRef,
      title: "优惠券兑换码管理",
      paginations: { pageSize: 10 },
      "page-layout": "total, sizes, prev, pager, next",
      columns: columns.value,
      "get-data": _unref(getData),
      "on-add": _unref(addFun),
      "on-delete": _unref(deleteFun),
      "on-edit": _unref(updateFun),
      loading: loading.value,
      "is-dangder-delete": true,
      "format-dangder-delete-info": formatDeleteInfo,
      "row-key": "id",
      operates: operates,
      "add-init-values": addInitValue,
      "codition-init-values": conditionsInitValue
    }, null, 8, ["columns", "get-data", "on-add", "on-delete", "on-edit", "loading"])
  ]))
}
}

})